export default {
  signIn: 'Войти',
  signOut: 'Выйти',
  login: 'Логин',
  password: 'Пароль',
  togglePasswordVisibility: 'Переключить видимость пароля',
};
